// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Yroh","buttons":"RemoveExpirationActionButtons_buttons__2jKEI"};